import React, { ReactNode } from "react";

import { trackMixpanel } from "utils";

type AnchorProps = {
  children?: ReactNode | null;
  className?: string;
  disabled?: boolean;
  href?: string;
  mixpanelText?: string;
  size?: string;
  target?: string;
  to?: string;
  type?: string;
  onClick?: () => void;
};

export const Anchor = ({
  children = null,
  className = "",
  disabled = false,
  href = "",
  mixpanelText,
  size = "",
  target,
  to,
  type = "default",
  onClick = () => {},
}: AnchorProps) => {
  const classNames = `anchor-${type} ${size} ${disabled ? " disabled" : ""} ${className}`;
  return (
    <a
      href={href || to}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : ""}
      className={classNames}
      onClick={() => {
        onClick();
        trackMixpanel("ClickLink", {
          linkText: mixpanelText || (typeof children === "string" && children) || "undefined",
          link: href,
        });
        return true;
      }}
    >
      {children}
    </a>
  );
};

export default Anchor;
